module.exports = __webpack_public_path__ + "static/media/left-girl.a2d7436a.png";